import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PortalApp from "./PortalApp";
import WidgetApp from "./WidgetApp";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/widget/:channelId" element={<WidgetApp />} />
        <Route path="*" element={<PortalApp />} />
      </Routes>
    </Router>
  );
};

export default App;
